import React, { useEffect } from 'react';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as ChatIcon } from '@assets/svg/ic-chat.svg';

import Button from '@components/uikit/Button/Button';

import useTranslation from '@hooks/useTranslation';

import ChatWindow from './components/ChatWindow/ChatWindow';
import {
  type IHelperAiActiveChatResponse,
  useHelperAiActiveChatQuery,
} from './services/useHelperAiActiveChatQuery';
import { selectChatIsOpen, useChatActions } from './store/useChatStore';
import style from './style.module.scss';

const ChatComponent = () => {
  const { t } = useTranslation();

  const { setActiveChat, setChatIsOpen, setChatId } = useChatActions();
  const chatIsOpen = selectChatIsOpen();

  const onSuccess = (data: IHelperAiActiveChatResponse) => {
    if (data && !data?.hasOwnProperty('success')) {
      setActiveChat(data.messages);
      setChatId(data.id);
    }
  };

  useHelperAiActiveChatQuery({ onSuccess });

  return (
    <>
      <Button
        dataTooltipId="chat-btn"
        dataTooltipContent={t('Open AI Assistant')}
        type="primary"
        onClick={setChatIsOpen}
        rightElement={<ChatIcon className={style.chatIcon} />}
      />
      <Tooltip id="chat-btn" />
    </>
  );
};

export default ChatComponent;
